import {sortByProperty} from 'helpers/sorters';
import BaseLineup from 'services/sports/default/base-lineup';

export default class LineupTiers extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        team.sort(sortByProperty('rosterPositionName'));

        team.map((player) => {
            player.positionInLineup = 'T' + player.rosterPositionName;
        });
        return team;
    }
}
